<!--Component used to display FAQs-->

<template>
  <main>
    {{toAccordionArray()}}
    <mdb-container fluid>
      <mdb-row>
        <mdb-col>
          <mdb-container>
            <mdb-row class="py-5 px-2">
              <mdb-col class="text-center">
                  <h2 class="mb-3">Frequently Asked Questions</h2>
                <mdb-card>
                  <mdb-card-body>
                    <mdb-accordion :panes="panes" material></mdb-accordion>
                  </mdb-card-body>
                </mdb-card>
              </mdb-col>
            </mdb-row>
          </mdb-container>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </main>
</template>

<script>
import {
  mdbContainer, 
  mdbCol,
  mdbRow,
  mdbAccordion,
  mdbCard,
  mdbCardBody
} from "mdbvue"
export default {
  name: "FAQAccordion",
  props: {
    block: Object
  },
  components: {
    mdbContainer,
    mdbCol,
    mdbRow,
    mdbAccordion,
    mdbCard,
    mdbCardBody
  },
  data() {
    return {
      panes: []
    }
  },
  methods: {
    toAccordionArray() {
      var num_questions = this.block.value.length;
      for (var i = 0; i < num_questions; i++) {
        var pane = {
          title: this.block.value[i].value.question,
          content: this.block.value[i].value.answer
        };
        this.panes[i] = pane;
      }
    }
  }
}
</script>